// utils/sessionManager.js
const INACTIVITY_THRESHOLD = 3 * 24 * 60 * 60 * 1000; // 3 days in milliseconds
const LAST_ACTIVE_KEY = "lastActiveTimestamp";
const DEVICE_ID_KEY = "deviceIdentifier";

// Called after successful login or signup
export const initializeSession = () => {
  updateActivityTimestamp();
  getDeviceIdentifier();
  return true;
};

// Generate or retrieve a unique device ID
const getDeviceIdentifier = () => {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);
  if (!deviceId) {
    deviceId = `device_${Date.now()}_${Math.random()
      .toString(36)
      .substring(2, 15)}`;
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }
  return deviceId;
};

// Update the last active timestamp
export const updateActivityTimestamp = () => {
  localStorage.setItem(LAST_ACTIVE_KEY, Date.now().toString());
};

// Check if the user should be logged out based on inactivity
export const shouldLogoutDueToInactivity = () => {
  const lastActiveTimestamp = localStorage.getItem(LAST_ACTIVE_KEY);
  if (!lastActiveTimestamp) {
    updateActivityTimestamp();
    return false;
  }

  const currentTime = Date.now();
  const inactiveTime = currentTime - parseInt(lastActiveTimestamp);

  return inactiveTime > INACTIVITY_THRESHOLD;
};

// Check device consistency - helps prevent session hijacking
export const isCurrentDevice = () => {
  const storedDeviceId = localStorage.getItem(DEVICE_ID_KEY);
  return storedDeviceId === getDeviceIdentifier();
};

